export type WasteSortingExcelImportReport = {
  language: string;
  url: string;
};

const WasteSortingExcelImportUrls: Record<string, WasteSortingExcelImportReport[]> = {
  denmark: [
    { language: "Danish", url: "/excel-templates/waste-sorting/denmark/waste-sorting-import-danish.xlsx" },
    // { language: "English", url: "/excel-templates/waste-sorting/denmark/waste-sorting-import-english.xlsx" },
  ],
};

export default WasteSortingExcelImportUrls;
